import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { FormikHelpers } from 'formik';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCaretLeftBold } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { DefaultError, useQueryClient } from '@tanstack/react-query';
import {
  usePostDeliveryTemplate,
} from 'services/settings/digital-delivery-template';
import {
  digitalDeliveryTemplateInitialValues,
} from 'components/organisms/forms/settings/DigitalDeliveryTemplateForm';
import { ISetDeliveryTemplateRequest } from 'services/settings/digital-delivery-template/types';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const Create = () => {
  const queryClient = useQueryClient();
  const updateDeliveryTemplate = usePostDeliveryTemplate();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onSubmit = useCallback(
    async (
      values: ISetDeliveryTemplateRequest,
      helpers: FormikHelpers<ISetDeliveryTemplateRequest>
    ) => {
      await updateDeliveryTemplate.mutateAsync(values, {
        onError: async (error: DefaultError) => {
          onErrorShowAllErrorsToast(error);
        },
        onSuccess: async () => {
          await queryClient.invalidateQueries({ queryKey: ['deliveryTemplate'] });
          navigate('/settings/digital-delivery-template');
        },
      });
    },
    [updateDeliveryTemplate, navigate, queryClient]
  );

  return (
    <Form.DigitalDeliveryTemplate
      i18nextPrefix=''
      status={{
        displayMode: false,
        isLoading: false,
      }}
      initialValues={digitalDeliveryTemplateInitialValues}
      topbarContent={
        <div className='flex items-center gap-2'>
          <Button
            onClick={() => {
              const form = document.querySelector('form');
              if (form) {
                form.requestSubmit();
              }
            }}
            variant={BUTTON_VARIANT.submit}>
            <Button.Text text={t('button.save')} />
          </Button>
        </div>
      }
      backPath='/settings/digital-delivery-template'
      customBackItem={
        <Button
          onlyIcon
          onClick={() => navigate('/settings/digital-delivery-template')}>
          <Button.Description description={t('button.back')} />


          <Button.Icon icon={<PiCaretLeftBold />} />
        </Button>
      }
      onSubmit={onSubmit}
    />
  );
};

export default Create;
